/**
 * 网关实体
 * zxw
 * 2024-10-20
 */
import React, { Component } from 'react';
import { Modal, Input,Row,Col, Button,
    message,
    InputNumber,Radio, } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '设备直播';

const { TextArea } = Input;

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            number: '',
            name: '',
            serialNumber: '',
            channelNumber: 0,
            urlType: 'bind',
            streamNumber: 0, 
            brand: '',
            productNumber: '',
            platformNumber: 'LC',
            description: '',
        }
    }
    changeNumber = (e) =>{this.setState({number: e.target.value});}
    changeName = (e) =>{this.setState({name: e.target.value});}
    changeSerialNumber = (e) =>{this.setState({serialNumber: e.target.value});}
    changeChannelNumber = (value) =>{this.setState({channelNumber: value});}
    changeUrlType = (e) =>{this.setState({urlType: e.target.value});}
    changeStreamNumber = (e) =>{this.setState({streamNumber: e.target.value});}
    changeBrand = (e) =>{this.setState({brand: e.target.value});}
    changeProductNumber = (e) =>{this.setState({productNumber: e.target.value});}
    changePlatformNumberr = (e) =>{this.setState({platformNumber: e.target.value});}
    changeDescription = (e) =>{this.setState({description: e.target.value});}
    create = () =>{
        const _this = this;

        //  执行创建
        $.ajax({
            url: `${CNF.api}vs/devlss`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'number': this.state.number,
                'name': this.state.name,
                'serial_number': this.state.serialNumber,
                'channel_number': this.state.channelNumber,
                'url_type': this.state.urlType,
                'stream_number': this.state.streamNumber,
                'brand': this.state.brand,
                'product_number': this.state.productNumber,
                'platform_number': this.state.platformNumber,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}vs/devlss/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'number': this.state.number,
                'name': this.state.name,
                'serial_number': this.state.serialNumber,
                'channel_number': this.state.channelNumber,
                'url_type': this.state.urlType,
                'stream_number': this.state.streamNumber,
                'brand': this.state.brand,
                'product_number': this.state.productNumber,
                'platform_number': this.state.platformNumber,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        //  编码
        if(this.state.number === ''){
            message.error('编码不能为空！');
            return;
        }
        //  名称
        if(this.state.name === ''){
            message.error('名称不能为空！');
            return;
        }
        //  序列号
        if(this.state.serialNumber === ''){
            message.error('序列号不能为空！');
            return;
        }

        this.setState({loading: true});
        if (this.props.record){
            this.update();
        }else{
            this.create();
        }
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            number: '',
            name: '',
            serialNumber: '',
            channelNumber: 0,
            urlType: '',
            streamNumber: 0, 
            brand: '',
            productNumber: '',
            platformNumber: 'LC',
            description: '',
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                number: this.props.record.number,
                name: this.props.record.name,
                serialNumber: this.props.record.serial_number,
                channelNumber: this.props.record.channel_number,
                urlType: this.props.record.url_type,
                streamNumber: this.props.record.stream_number,
                brand: this.props.record.brand,
                productNumber: this.props.record.product_number,
                platformNumber: this.props.record.platform_number?this.props.record.platform_number:'LC',
                description: this.props.record.description,
            });
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={700}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    okText='确认'
                    cancelText='取消'
                    footer={[
                        <Button key="cancel" disabled={this.state.loading} onClick={this.handleCancel}>取消</Button>,
                        <Button key="ok" type="primary" disabled={this.state.loading} onClick={this.handleOk}>确定</Button>,
                      ]}
                    // style={{ top: 0 }}
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>编码：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeNumber}
                                placeholder='必填字段'
                                value={this.state.number}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>名称：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeName}
                                placeholder='必填字段'
                                value={this.state.name}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={3}>序列号：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeSerialNumber}
                                placeholder='必填字段'
                                value={this.state.serialNumber}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>通道号：</Col>
                        <Col span={8}>
                            <InputNumber
                                onChange={this.changeChannelNumber}
                                value={this.state.channelNumber}
                                min={0}
                                max={999}
                                step={1}
                                style={{ width: '100%' }}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={4}>直播地址类型：</Col>
                        <Col span={20}>
                            <Radio.Group 
                                onChange={this.changeUrlType} 
                                value={this.state.urlType}
                            >
                                <Radio value='bind'>源</Radio>
                                <Radio value='flv'>flv</Radio>
                                <Radio value='rtmp' disabled={true}>rtmp协议</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={4}>码流类型：</Col>
                        <Col span={20}>
                            <Radio.Group 
                                onChange={this.changeStreamNumber} 
                                value={this.state.streamNumber}
                            >
                                <Radio value={0}>高清主码流</Radio>
                                <Radio value={1}>标清辅码流</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>品牌：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeBrand}
                                value={this.state.brand}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={3} offset={2}>产品编码：</Col>
                        <Col span={8}>
                            <Input
                                onChange={this.changeProductNumber}
                                value={this.state.productNumber}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={3} style={{ lineHeight: 2.2 }}>备注：</Col>
                        <Col span={21}>
                            <TextArea
                                placeholder='备注可写在这里...'
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={this.changeDescription}
                                disabled={this.state.loading}
                                value={this.state.description}
                            />
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity